import { motion } from "framer-motion";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { SITE } from "../data/site";

const EVENTS = [
  { date: "Mar 15", title: "USDD Open Cypher", venue: "Casino Rooms, Rochester" },
  { date: "Apr 06", title: "Kids Showcase Vol. 7", venue: "Central Theatre, Chatham" },
  { date: "May 18", title: "Battle of the South: 1v1 All Styles", venue: "Gillingham, Kent" },
  { date: "Jun 22", title: "USDD Graduation Performance", venue: "Brogdale, Faversham" },
];

export const Events = () => {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="relative py-24 sm:py-32 overflow-hidden noise"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7 relative rounded-3xl overflow-hidden border border-white/10"
          >
            <img src={SITE.battle} alt="USDD Battle Cypher" className="w-full h-full object-cover min-h-[420px]" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
            <div className="absolute top-6 left-6 px-4 py-2 rounded-full bg-brand-yellow text-black font-display font-black uppercase text-xs tracking-wide">
              Live · This Season
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <div className="text-[10px] uppercase tracking-[0.3em] text-brand-yellow mb-2">04 · Events & Battles</div>
              <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-[0.95]">
                Where the
                <br />
                culture <span className="italic text-brand-purpleLight">collides</span>.
              </h2>
            </div>
          </motion.div>

          <div className="lg:col-span-5 flex flex-col">
            <p className="text-zinc-400 text-base mb-8 max-w-md">
              Battles, cyphers, showcases and community jams. USDD events are
              run by dancers, for dancers — open to crews and solos across the UK.
            </p>
            <div className="flex-1 divide-y divide-white/10 border-y border-white/10">
              {EVENTS.map((e, i) => (
                <motion.a
                  key={e.title}
                  href="#contact"
                  data-testid={`event-row-${i}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="group flex items-center gap-5 py-5 hover:pl-2 transition-all"
                >
                  <div className="flex flex-col items-center w-14 shrink-0">
                    <span className="text-[10px] uppercase tracking-widest text-zinc-500">{e.date.split(" ")[0]}</span>
                    <span className="font-display font-black text-2xl text-brand-yellow">{e.date.split(" ")[1]}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-white text-lg group-hover:text-brand-yellow transition-colors truncate">
                      {e.title}
                    </div>
                    <div className="flex items-center gap-1.5 text-xs text-zinc-500 mt-1">
                      <MapPin size={11} />
                      {e.venue}
                    </div>
                  </div>
                  <ArrowRight className="text-zinc-600 group-hover:text-brand-yellow group-hover:translate-x-1 transition-all" size={18} />
                </motion.a>
              ))}
            </div>
            <a
              href="#contact"
              data-testid="events-all-btn"
              className="mt-8 inline-flex items-center gap-2 self-start px-6 py-3 rounded-full border-2 border-white/30 text-white font-bold uppercase text-sm tracking-wider hover:bg-white hover:text-black transition-all"
            >
              <Calendar size={16} />
              See all events
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
